import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { GlobalModalTypeEnum } from 'enums/entity';

import useQueryParams from './useQueryParams';

type GlobalModalType = {
  modalType: GlobalModalTypeEnum | null;
  setModalType: (value: GlobalModalTypeEnum | null) => void;
  openGlobalModal: (name: GlobalModalTypeEnum) => void;
};

const useGlobalModal = (): GlobalModalType => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = useQueryParams();
  const [modalType, setModalType] = useState<GlobalModalTypeEnum | null>(null);

  const openGlobalModal = (name: GlobalModalTypeEnum): void => {
    const modalName = queryParams.get('modal');
    if (modalName) {
      location.search = location.search.replace(modalName, name);
    } else {
      location.search += location.search ? `&modal=${name}` : `?modal=${name}`;
    }
    setModalType(name);
    navigate(location, { replace: false });
  };

  return {
    modalType,
    setModalType,
    openGlobalModal,
  };
};

export default useGlobalModal;
